import React, { useEffect } from "react";
import chevronleft from '../../../../../Assets/images/double chevron-left.svg';
import noteAdd from '../../../../../Assets/images/note-add.svg';
import phone from '../../../../../Assets/images/phone.svg';
import history from '../../../../../Assets/images/history.svg';
import noteAddGreen from '../../../../../Assets/images/note-add-green.svg';
import phoneGreen from '../../../../../Assets/images/phone-green.svg';
import historyGreen from '../../../../../Assets/images/history-green.svg';

function CustomerDrawerCollapse(props) {

  useEffect(() => {
    //TODO:
  });

  const expand = () => {
    props.expandCollapse(true);
  }

  return (
    <React.Fragment>
      <div className="drawer-wrapper">
        <div className="page-side rdrawer">
          <div className="side-header">
            <div className="expand-arrow" onClick={ () => {expand()} } ><img src={chevronleft} alt=""/></div>
            <ul className="service-icons-vert">
              <li className={`ant-menu-item active`}>
                <img className="normal" src={noteAdd} alt="" />
                <img className="hover" src={noteAddGreen} alt="" />
              </li>
              <li className={`ant-menu-item`}>
                <img className="normal" src={phone} alt="" />
                <img className="hover" src={phoneGreen} alt="" />
              </li>
              <li className={`ant-menu-item`}>
                <img className="normal" src={history} alt="" />
                <img className="hover" src={historyGreen} alt="" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default CustomerDrawerCollapse;